module.exports = __webpack_public_path__ + "images/2-i-oldb98b76feda697ef62c64d784870704d9.svg";